import { useDeleteEmailMutation } from "@common/api/emails"
import { handleError } from "@common/utils"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { DeleteDialog } from "@/components/layout/list-table-menu"
import useCustomToast from "@/hooks/use-custom-toast"
import { requirePermission } from "@/lib/require-permission"

export const Route = createFileRoute(
  "/_layout/quoting_/emails/_list/delete/$emailId",
)({
  beforeLoad: ({ context: { queryClient } }) =>
    requirePermission(queryClient, "email:delete", "/"),
  component: DeleteEmailDialog,
})

function DeleteEmailDialog(): React.ReactElement {
  const { emailId } = Route.useParams()
  const navigate = useNavigate()
  const showToast = useCustomToast()
  const remove = useDeleteEmailMutation()

  const close = () => navigate({ to: "/quoting/emails", search: true })

  return (
    <DeleteDialog
      noun="email"
      pending={remove.isPending}
      onCancel={close}
      onConfirm={() =>
        remove.mutate(
          { email_id: emailId },
          {
            onSuccess: () => {
              showToast("Deleted", "Email deleted.", "success")
              close()
            },
            onError: (error) => handleError(error, showToast),
          },
        )
      }
    />
  )
}
